// extracted by mini-css-extract-plugin
module.exports = {"form":"styles_form__2Um6O","row":"styles_row__22qFi"};